// extracted by mini-css-extract-plugin
module.exports = {"addUser":"addUser__3f_Pb","error":"error__3Qqzo","title":"title__3gsGX","seats":"seats__1y8QU","addUserButton":"addUserButton__2KzxD"};